module.exports = __webpack_public_path__ + "images/logo-expert.jpg?47e3c93f8b237004dbdc61f71c65be9f";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/logo-expert.jpg
// module id = 982
// module chunks = 0